import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { opacity, overflow } from 'styled-system';

interface RatioOuterProps {
  ratio?: number;
  /** Ratio value */
  ratioOpacity?: number;
  ratioOverflow?: string;
  children?: React.ReactNode;
}

const RatioOuter = styled.div<any>`
  ${opacity};
  ${overflow};
  width: 100%;
  height: 0;
  padding-bottom: calc(100% * ${props => props.ratio});
  position: relative;
`;

const ratioOuterStyles: ComponentProps<typeof RatioOuter> = {
  overflow: 'hidden',
  opacity: 1,
};

const RatioInner = styled.div<any>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Ratio = ({ ratio = 1, ratioOverflow, ratioOpacity, ...props }: RatioOuterProps) => (
  <RatioOuter
    {...ratioOuterStyles}
    data-testid="ratio-outer"
    ratio={ratio || 1}
    overflow={ratioOverflow}
    opacity={ratioOpacity}
  >
    <RatioInner {...props} />
  </RatioOuter>
);

export default Ratio;
